import { createContext } from 'react'

const dynamicContext = createContext()

export default dynamicContext
